module.exports = __webpack_public_path__ + "static/media/playertable icon-2.b1af8e45.svg";